import { useEffect, VFC } from 'react'
import { useFormContext } from 'react-hook-form'
import { MasterDataWithCategory } from 'src/models/MasterData'
import { _needs_form_background, _needs_form_border } from 'src/styles/colors'
import styled from 'styled-components'
import { SelectableItemDiv, SelectableItems } from './common'

type NeedsSelectProps = { id: string; items: MasterDataWithCategory[] }

export const NeedsSelect: VFC<NeedsSelectProps> = ({ id, items }) => {
  const { register, watch, reset } = useFormContext()
  const selectedValues = watch(id) as MasterDataWithCategory[]
  const updateSelectedValue = (
    selected: MasterDataWithCategory,
    checked: boolean,
  ) =>
    checked
      ? reset({ [id]: [...selectedValues, selected] })
      : reset({
          [id]: selectedValues.filter((each) => each.value !== selected.value),
        })
  useEffect(() => {
    register(id)
  }, [id, register])

  return (
    <NeedsSelectComponent
      items={items}
      selectedValues={selectedValues}
      updateSelectedValue={updateSelectedValue}
    />
  )
}

type NeedsCategoriesProps = {
  items: MasterDataWithCategory[]
  selectedValues: MasterDataWithCategory[]
  updateSelectedValue: (
    selected: MasterDataWithCategory,
    checked: boolean,
  ) => void
}

export const NeedsSelectComponent: VFC<NeedsCategoriesProps> = ({
  items,
  selectedValues,
  updateSelectedValue,
}) => {
  const categories = [
    {
      title: '経営戦略・事業開発',
      items: items.filter((item) => item.category === '経営戦略・事業開発'),
    },
    {
      title: 'ブランディング・マーケティング',
      items: items.filter(
        (item) => item.category === 'ブランディング・マーケティング',
      ),
    },
    {
      title: 'セールス強化・売上拡大',
      items: items.filter((item) => item.category === 'セールス強化・売上拡大'),
    },
    {
      title: '人材採用',
      items: items.filter((item) => item.category === '人材採用'),
    },
    {
      title: '人・組織づくり',
      items: items.filter((item) => item.category === '人・組織づくり'),
    },
    {
      title: '業務改善・システム開発・デジタル化',
      items: items.filter(
        (item) => item.category === '業務改善・システム開発・デジタル化',
      ),
    },
    {
      title: '財務・資金管理・バックオフィス',
      items: items.filter(
        (item) => item.category === '財務・資金管理・バックオフィス',
      ),
    },
    {
      title: 'その他',
      items: items.filter((item) => item.category === 'その他'),
    },
  ]
  return (
    <Layout>
      {categories.map(({ title, items: categoryItems }) => (
        <Wrapper key={title}>
          <Title>{title}</Title>
          <SelectableItems>
            {categoryItems.map((option) => (
              <SelectableItemDiv key={option.value}>
                <input
                  id={option.value}
                  type="checkbox"
                  onChange={({ target: { checked } }) =>
                    updateSelectedValue(option, checked)
                  }
                  checked={selectedValues.some(
                    ({ value }) => option.value === value,
                  )}
                />
                <label htmlFor={option.value}>{option.label}</label>
              </SelectableItemDiv>
            ))}
          </SelectableItems>
        </Wrapper>
      ))}
    </Layout>
  )
}

const Layout = styled.div`
  border: 2px solid ${_needs_form_border};
  border-radius: 15px;

  & > div:nth-child(odd) {
    background-color: ${_needs_form_background};
  }
`
const Wrapper = styled.div`
  padding: 16px 24px;
`
const Title = styled.div`
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 8px;
`
